export var ContentStatus;
(function (ContentStatus) {
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ACTIVE"] = "ACTIVE";
})(ContentStatus || (ContentStatus = {}));
